import EmpresaMapper from "@/common/contabil/EmpresaMapperAdapter";
import { IEvolucaoPatrimonioStrategy } from "./EvolucaoPatrimonioStrategy";
import { IEmpresaResponse } from "@/services/contabil/shared/requests/types";

export interface IDetalhesPatrimonioAnualAtivoResponse {
  ativoTotal?: number;
  ativoCirculante?: number;
  disponibilidades?: number;
  creditos?: number;
  estoques?: number;
  despesasExercicioSeguinte?: number;
  ativoBiologicoCirculante?: number;
  ativoNaoCirculanteMantidoParaVenda?: number;
  ativoNaoCirculante?: number;
  realizavelALongoPrazo?: number;
  investimentos?: number;
  imobilizado?: number;
  intangivel?: number;
  diferido?: number;
}

export interface IDetalhesPatrimonioAnualDREResponse {
  resultadoLiquidoDoPerido?: number;
  resultdoLiquidoDoPeriodoAntesDoIRPJeCSLLAtividadeGeral?: number;
  resultadoOperacional?: number;
  receitaLiquida?: number;
  custoDosBensServicos?: number;
  outrasReceitasOperacionais?: number;
  despesasOperacionais?: number;
  outrasDespesasOperacionais?: number;
  outrasReceitasDespesasEResultadoOperacoesDescontinuadas?: number;
  participacoes?: number;
  provisaoCsllIrpj?: number;
}

export interface IDetalhesPatrimonioAnualPassivosResponse {
  passivoTotalComPatrimonioLiquido?: number;
  passivoCirculante?: number;
  obrigacoesCirculante?: number;
  passivoNaoCirculante?: number;
  obrigacoesALongoPrazo?: number;
  patrimonioLiquido?: number;
  capitalSocial?: number;
  reservas?: number;
  ajustesDeAvalicaoPatrimonial?: number;
  outrasContasDoPatrimonioLiquido?: number;
}

export interface IDetalhesPatrimonioAnualResponse {
  ano: string;
  ativos: IDetalhesPatrimonioAnualAtivoResponse;
  dre: IDetalhesPatrimonioAnualDREResponse;
  passivos: IDetalhesPatrimonioAnualPassivosResponse;
}

export interface IDetalhesEvolucaoPatrimonioEmpresaResponse
  extends IEmpresaResponse {
  certificadoInvalido: boolean;
  detalhesPatrimonioAnual?: IDetalhesPatrimonioAnualResponse[];
}

export interface IDetalhesEvolucaoPatrimonioResponse {
  empresas: IDetalhesEvolucaoPatrimonioEmpresaResponse[];
}

export interface IDetalhesEvolucaoPatrimonioParams {
  empresas: string[];
}

export default class DetalhesEvolucaoPatrimonio {
  constructor(
    readonly response: IDetalhesEvolucaoPatrimonioResponse | undefined
  ) {}

  private findByYear(
    detalhes: IDetalhesEvolucaoPatrimonioEmpresaResponse | undefined,
    year: number
  ) {
    return detalhes?.detalhesPatrimonioAnual?.find(
      (detalhe) => Number(detalhe.ano) === year
    );
  }

  getEmpresasByYear(year: number) {
    return (
      this.response?.empresas
        .map((empresa) => {
          const detalhe = empresa.detalhesPatrimonioAnual?.find(
            (detalhe) => Number(detalhe.ano) === year
          );

          return {
            ...detalhe,
            empresa: EmpresaMapper.toEntity(empresa)
          };
        })
        .flat() || []
    );
  }

  handleDetalhes<T>(
    year: number,
    cnpj: string,
    strategy: IEvolucaoPatrimonioStrategy<T>
  ) {
    const empresa = this.response?.empresas.find(
      (empresa) => empresa.cnpj.completo === cnpj
    );

    const detalhes = this.findByYear(empresa, year);

    return strategy.handleDetalhes(detalhes);
  }

  handleGetValue<T>(
    strategy: IEvolucaoPatrimonioStrategy<T>,
    value: T,
    key: keyof T
  ) {
    return strategy.handleGetValue(value, key);
  }
}
